import { OnInit, Component, Inject, Optional } from '@angular/core';
import { IContextService } from '@pershing/pershing-core';
import { NxiRestService } from '../../services/NXI-Rest.service';
import { NxiWidgetParamsService } from '../../services/NXI-WidgetParams.service';
import { Location } from '@angular/common';
import { SSOUtil } from '../../model/SSOUtil';
import { DomainContext } from '@pershing/pershing-core';
import { ActivatedRoute } from '@angular/router';
import { PershingTranslationService } from '@pershing/pershing-core';
import { DomSanitizer } from '@angular/platform-browser';
import { NxiContextUtils } from '@pershing/nxi-common';

@Component({
    selector: 'hewittPayroll-component',
    templateUrl: './hewittPayroll-component.html'
})

export class HewittPayrollComponent implements OnInit {
    appSettings: any;
    challengeURL: string;
    timeStamp: string;
    signedValue: string;
    userRefNum: string;
    acctRef: any;
    inputValue: any;
    ssoUrl: string;
    ssoFullUrl: string;
    isMacLike: boolean;
    isIOS: boolean;
    IOSMessage: boolean;
    gfUrl: string;
    constructor(private contextService: IContextService,
                private nxiRestService: NxiRestService,
                private location: Location,
                private translationService: PershingTranslationService,
                private nxiWidgetParamsService: NxiWidgetParamsService,
                private route: ActivatedRoute,
                @Optional() @Inject('AppSettings') appSettings: any,
                private sanitizer: DomSanitizer) {
                    this.appSettings = appSettings;
                    this.translationService.addTranslationFolder('@pershing/nxi-ng-portfolio', 'node_modules/@pershing/nxi-ng-portfolio/lib');
    }

    ngOnInit() {
        // Call the wiget params service to get the valid args
        this.contextService.selectedDomainContext$.subscribe((domainContext: DomainContext<any>) => {
            let contextValue = NxiContextUtils.getContextFromDomainValue(domainContext);
            this.inputValue = contextValue.inputValue;
            this.acctRef = contextValue.hashValue;
            this.widgetsParamService();
        });
        this.isMacLike = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
        this.isIOS = /(iPhone|iPod|iPad)/i.test(navigator.platform);
        this.IOSMessage = SSOUtil.isIos( this.isMacLike, this.isIOS);
    }

    openNewWindow() {
        window.open(this.ssoFullUrl, 'hewittPayroll' , 'resizable=yes,scrollbars=yes,statusbar=yes,toolbar=no,menubar=no').focus();
    }

    widgetsParamService() {
        this.nxiWidgetParamsService.getWidgetParam('/commonrest/hewittPayroll').subscribe(
            resp => {
                if (resp.response) {
                    this.userRefNum = resp.response.userRefNum;
                    this.ssoFullUrl = resp.response.ssoUrl + '&SSOIndicator=NXI_SSOOUT_SPINIT_HEWITTPAYROLL&Target=HewittPayroll&AcctId=' +
                                        this.inputValue + '&UserRefNum=' +  this.userRefNum;
                    this.gfUrl = '/401kelection/alightInvestAllocation.do?SourceIBD=Alight&Target=HewittPayroll&AcctId='+this.inputValue + '&UserRefNum=' +  this.userRefNum;
                }
            }
        );
    }

}
